import React, { Component } from 'react'
import StyledButton from './StyledButton';

export default class SmallButton extends Component {
    render() {
        return (
            <div style={{ flex: '1' }}>
                <StyledButton className={this.props.className} onClick={this.props.onClick}>{this.props.buttonLabel}</StyledButton>
            </div>
        )
    }
}
